import React, { useEffect, useState } from 'react';
import { Typography, Table, Card, Tag, Button, Space, message } from 'antd';
import type { TableColumnsType } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { ErrorLog } from '../../types';
import { logsApi } from '../../api/logs';

const { Title } = Typography;

const Logs: React.FC = () => {
  const [logs, setLogs] = useState<ErrorLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);

  const load = async (p = page, s = pageSize) => {
    setLoading(true);
    try {
      const data = await logsApi.getLogs(p, s);
      setLogs(data.content);
      setTotal(data.totalElements);
    } catch (error: any) {
      message.error(error?.response?.data?.message || '로그를 불러오는데 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const getStatusTag = (status: string) => {
    if (status === 'ERROR') return <Tag color="error">에러</Tag>;
    if (status === 'SKIPPED') return <Tag color="warning">스킵</Tag>;
    return <Tag>{status}</Tag>;
  };

  const columns: TableColumnsType<ErrorLog> = [
    { title: 'ID', dataIndex: 'id', width: 80 },
    {
      title: '시각',
      dataIndex: 'createdAt',
      width: 180,
      render: (val) => val ? new Date(val).toLocaleString('ko-KR') : '-',
    },
    { title: '설정 ID', dataIndex: 'settingId', width: 100 },
    { title: 'Source', dataIndex: 'sourceAccount', width: 120 },
    { title: 'Target', dataIndex: 'targetAccount', width: 120 },
    { title: '이벤트', dataIndex: 'eventType', width: 140 },
    { title: '심볼', dataIndex: 'symbol', width: 100 },
    { title: '상태', dataIndex: 'status', width: 80, render: getStatusTag },
    { title: '스킵 사유', dataIndex: 'skipReason', width: 150 },
    { title: '에러 메시지', dataIndex: 'errorMessage', ellipsis: true },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={2} style={{ margin: 0 }}>에러 로그</Title>
        <Space>
          <Button icon={<ReloadOutlined />} onClick={() => load(page, pageSize)} loading={loading}>
            새로고침
          </Button>
        </Space>
      </div>

      <Card>
        <Table<ErrorLog>
          rowKey="id"
          columns={columns}
          dataSource={logs}
          loading={loading}
          pagination={{
            current: page + 1,
            pageSize,
            total,
            showSizeChanger: true,
            showTotal: (t) => `총 ${t}건`,
            onChange: (p, s) => {
              setPage(p - 1);
              setPageSize(s);
              load(p - 1, s);
            },
          }}
          scroll={{ x: 1400 }}
        />
      </Card>
    </div>
  );
};

export default Logs;
